import { Component, effect, inject } from '@angular/core';
import { Router } from '@angular/router';
import { UserStore } from '@bn/auth/stores';
import { SupportDepartmentType } from '@bn/shared/entities/enums';
import { NotAvailableComponent } from '@bn/web-ui/not-available/not-available-component/not-available.component';

@Component({
  selector: 'bn-account-suspended',
  templateUrl: './account-suspended.page.html',
  imports: [NotAvailableComponent],
})
export class AccountSuspendedPage {
  readonly #router = inject(Router);
  readonly userStore = inject(UserStore);

  protected readonly SupportDepartmentType = SupportDepartmentType;

  constructor() {
    effect(() => {
      if (!this.userStore.isSuspended()) {
        this.#router.navigate(['/']);
      }
    });
  }
}
